import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/alt-text */ import Link from 'next/link'; // import Image from 'next/image'
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ExegesisMech } from '../components/ExegesisMech';
import HomeLayout from '../components/HomeLayout';
import { colors, DarkenSlightly, DefaultFont, fontSizes } from '../styles/themes';
import { useAuthor } from '../utils/useAuthor';
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 50px;\n  @media only screen and (max-width: 600px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  object-fit: cover;\n  height: 70vh;\n  margin-left: auto;\n  margin-right: auto;\n  background-color: ",
        ";\n\n  border-radius: 30px;\n\n  filter: brightness(92.5%);\n\n  @media only screen and (max-width: 1124px) {\n    height: auto;\n    width: 100%;\n  }\n\n  margin-bottom: 200px;\n  @media only screen and (max-width: 850px) {\n    margin-bottom: 100px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  height: 150px;\n  @media only screen and (max-width: 850px) {\n    height: 50px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  min-height: 100vh;\n  h1 {\n    font-size: 4rem;\n    line-height: 1.15;\n  }\n  @media only screen and (max-width: 850px) {\n    display: block;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 85px;\n  @media only screen and (max-width: 850px) {\n    padding-top: 0px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  p {\n    font-size: ",
        ";\n  }\n  p,\n  h1,\n  h2,\n  h3 {\n    color: ",
        ";\n    font-family: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: bold;\n  margin-top: 10px;\n  font-size: 2rem;\n  padding: 10px;\n  border: none;\n  color: ",
        ";\n  border-radius: 10px;\n  background-color: ",
        ";\n  :hover {\n    background-color: ",
        ";\n  }\n  :hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
export var COPY_AUTHOR = 'NgoLSKVFbFdTv2cnsvzhgUAvMR02'; // shrinking factor: 3.185?
var mecha = '/iso_mech.png';
var ship = '/iso_ship.png';
var steampunk_building_1 = '/iso_steampunk_building.png';
var greek = '/iso_greek.png';
export default function Home() {
    useEffect(function() {
        useAuthor.setState({
            author: COPY_AUTHOR
        });
    }, []);
    return(/*#__PURE__*/ _jsx(HomeContainer, {
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs(MechAndTitle, {
                    children: [
                        /*#__PURE__*/ _jsxs(TextBox, {
                            children: [
                                /*#__PURE__*/ _jsxs("h1", {
                                    children: [
                                        "A writing app ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "for creative thinking"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "/login",
                                    passHref: true,
                                    children: /*#__PURE__*/ _jsx(CallToActionButton, {
                                        children: "open app"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(ExegesisMech, {})
                    ]
                }),
                /*#__PURE__*/ _jsxs(TextDiv, {
                    children: [
                        /*#__PURE__*/ _jsxs("h1", {
                            children: [
                                '"',
                                "Got treasures in my mind but couldn",
                                "'",
                                "t open up my own vault",
                                '"'
                            ]
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "https://youtu.be/k8JflBNovLE?t=112",
                                rel: "noopener noreferrer",
                                target: "_blank",
                                children: "-Kanye West, POWER"
                            })
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            children: [
                                "exegesis",
                                "'",
                                " philosophy is simple:",
                                ' ',
                                /*#__PURE__*/ _jsx("b", {
                                    children: "write now, organize later."
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: "Ideas have a half life. A writing app should help you get them down fast, not get in your way with clunky abstractions like notebooks."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Spacer, {}),
                /*#__PURE__*/ _jsxs(TextDiv, {
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            children: "Tag everything"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: "Write ideas down at the speed of thought, then organize them later with tags."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(DemoVideo, {
                    autoPlay: true,
                    muted: true,
                    loop: true,
                    src: "./tagging.mp4"
                }),
                /*#__PURE__*/ _jsxs(TextDiv, {
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            children: "Focus on what matters"
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            children: [
                                "exegesis",
                                "'",
                                " dashboard gives you control over what you see. Customize it with widgets, so your most important thoughts and ideas are always just a click away."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(DemoVideo, {
                    autoPlay: true,
                    muted: true,
                    loop: true,
                    src: "./widgets.mp4"
                }),
                /*#__PURE__*/ _jsxs(TextDiv, {
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            children: "Share your thoughts with the world"
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            children: [
                                "Not only does exegesis helps you find and use your best ideas, it",
                                "'",
                                "s also a place for you to share them. Published notes have the same tags, so readers can see the links and connections between your ideas."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(DemoVideo, {
                    autoPlay: true,
                    muted: true,
                    loop: true,
                    src: "./publicprofile.mp4"
                })
            ]
        })
    }));
};
Home.layout = HomeLayout;
var TextDiv = styled.div(_templateObject());
var DemoVideo = styled.video(_templateObject1(), DarkenSlightly);
var Spacer = styled.div(_templateObject2());
var MechAndTitle = styled.div(_templateObject3());
var TextBox = styled.div(_templateObject4());
var HomeContainer = styled.div(_templateObject5(), fontSizes[2][1], colors.lightOffBlack, DefaultFont);
var CallToActionButton = styled.button(_templateObject6(), fontSizes[2][1], colors.lightOffBlack, function(props) {
    return props.theme.colors.main.medium;
}, function(props) {
    return props.theme.colors.main.dark;
});
